/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Edit from '@material-ui/icons/Edit';
import AddCircle from '@material-ui/icons/AddCircle';

const styles = (theme) => ({
    labelName: {
        color: theme.palette.grey,
    },
    verticalAlignMiddle: {
        verticalAlign: 'middle',
    },
    minHeightDiv: {
        minHeight: '123px',
    },
    messageWidth: {
        width: '140px',
    },
});
class DesktopAccountWalletInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = { defaultCard: '' };
    }

    getCardTypeById = (cardtypes, id) => {
        let cardTypeName = null;
        if (cardtypes) {
            const listCardType = cardtypes.filter((c) => c.id === id) || [];
            if (listCardType.length) {
                cardTypeName = listCardType[0].name;
            }
        }
        return cardTypeName;
    }

    handleSetDefaultCardClicked = (walletId) => {
        const { onSetDefaultCard } = this.props;
        this.setState({ defaultCard: walletId }, () => {
            onSetDefaultCard(walletId);
        });
    };

    render() {
        const {
            wallet,
            cardtypes,
            billingAddress,
            countries,
            onEditCard,
            classes,
        } = this.props;
        const { defaultCard } = this.state;

        const setAdDefaultButton = (walletId) => (defaultCard === walletId ? (
            <div className="margin-top">Set As Default...</div>
        ) : (
            <button
                className="remove-cc-btn link margin-top"
                onClick={() => this.handleSetDefaultCardClicked(walletId)}
                type="button"
            >
                Set As Default
            </button>
        ));
        return (
            <>
                {wallet.map((w) => (
                    w.subsIndicator === '1'
                        ? (
                            <div key={w.walletId}>
                                <div className="padding-right padding-top gray-color align-right small">*Default</div>
                                <div className="padding">
                                    <div className={classes.minHeightDiv}>
                                        <div className="split">
                                            <div className="bold">
                                                {this.getCardTypeById(cardtypes, w.cardType)}
                                            </div>
                                        </div>
                                        <div>
                                            &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                            <span className="bold">{w.lastFourDigits}</span>
                                        </div>
                                        <div className="bold">{w.cardHolderName}</div>
                                        <div className="split bold">
                                            <div>exp. {w.expiryDate}</div>
                                        </div>
                                        {w.subsIndicator === '0'
                                            ? setAdDefaultButton(w.walletId)
                                            : ''}
                                        <div
                                            className={
                                                w.subsIndicator === '1'
                                                    ? 'margin-top small gray-color'
                                                    : 'display-none'
                                            }
                                        >
                                            * Used for Subscription &amp; Passport
                                            membership
                                        </div>
                                    </div>

                                    <div className="blue-color align-right">
                                        <span className="link-button" role="presentation" onClick={() => onEditCard({ ...w, billingAddress, countries }, 'desktop')}>
                                            <Edit className={`link-icon ${classes.verticalAlignMiddle}`} />
                                            <span className="link-label">Edit</span>
                                        </span>
                                        <span className="padding-left-right-10">&#124;</span>
                                        <span className="link-button" role="presentation" onClick={() => onEditCard({ defaultCreditCard: w, billingAddress, countries }, 'desktop')}>
                                            <AddCircle className={`link-icon ${classes.verticalAlignMiddle}`} />
                                            <span className="link-label">Add</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                        : null
                ))}
                {wallet.length === 0 ? (
                    <>
                        <div className="min-height-15x">
                            <p className={`bold padding-top-4x padding-bottom-4x padding-left no-wrap ${classes.messageWidth}`}>
                                You do not have any  credit cards on file.
                            </p>
                            <div className="blue-color align-right padding-right padding-bottom position-absolute-bottom">
                                <span className="link-button" role="presentation" onClick={() => onEditCard({ billingAddress, countries }, 'desktop')}>
                                    <AddCircle className={`link-icon ${classes.verticalAlignMiddle}`} />
                                    <span className="link-label">Add</span>
                                </span>
                            </div>
                        </div>
                    </>
                ) : (
                    ''
                )}

            </>
        );
    }
}

DesktopAccountWalletInfo.defaultProps = {
    billingAddress: [],
};

DesktopAccountWalletInfo.propTypes = {
    wallet: PropTypes.array.isRequired,
    cardtypes: PropTypes.array.isRequired,
    billingAddress: PropTypes.array,
    countries: PropTypes.array.isRequired,
    onEditCard: PropTypes.func.isRequired,
    onSetDefaultCard: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(DesktopAccountWalletInfo);
